export default "__VITE_ASSET__BS1_i_ut__"